import logo from './logo.svg';
import './App.css';
import AiExpertsEdgeLandingPage from './RoutesContainer/RouteContainer';

function App() {
  return (
    <>
      <AiExpertsEdgeLandingPage />
    </>
  );
}

export default App;
